import * as Yup from "yup"
import { MESSAGE_ERREUR_SITEINTERNET_FORMAT } from "../../data/message-erreurs-form";
const RegExWebSite = /^(https?:\/\/)?(www\.)[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_.~#?&//=]*)|(https?:\/\/)?(www\.)?(?!ww)[-a-zA-Z0-9@:%._~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_.~#?&//=]*)$/;


    export const webSiteSchema = () =>
      Yup.string()
        .nullable() // Permet au champ d'être null ou undefined
        .transform((value, originalValue) => (originalValue === '' ? null : value)) // Transforme une chaîne vide en null
        .matches(RegExWebSite, MESSAGE_ERREUR_SITEINTERNET_FORMAT)
        .notRequired(); // Le champ n'est pas obligatoire



